/**
 * Converts an already-filtered image attachment list to GalleryItem[].
 * Uses if/return rather than a ternary so TypeScript narrows `kind` to the
 * exact literal type required by the GalleryItem union without a cast.
 */
const buildGalleryItems = imageAttachments => imageAttachments.map(fileMetadata => {
  if (fileMetadata.extension === 'gif') {
    return {
      kind: 'gif',
      fileMetadata
    };
  }
  return {
    kind: 'image',
    fileMetadata
  };
});
export default buildGalleryItems;